import React, { useMemo } from 'react';
import { useGetModernizationSavingsQuery } from '../../api/discovery/inventory';
import {
    parseModernizationSavingsResponse,
    modernizationSavingsCardValues,
    parsePotentialSavingsResponse,
    potentialSavingsCardValues,
    parseTopTenOpportunitiesResponse,
    topTenOpportunitiesCardValues,
} from '../Card/CardParsers';
import { CARD_TYPES } from '../Card/cardTypes';
import { SummaryCardRenderer, buildCards } from '../Card/SummaryCardRenderer';

export const SummaryDetailsSection = ({ summaryData, onIgnoreOptimizations, queryState }) => {
    const { data: modernizationPricingData, isLoading: isPricingLoading, isError: isPricingError } = useGetModernizationSavingsQuery();

    const getCardConfigs = () => [
        {
            id: 'modernizationSavings',
            cardType: CARD_TYPES.DETAILS,
            parseResponse: parseModernizationSavingsResponse,
            values: modernizationSavingsCardValues,
        },
        {
            id: 'potentialSavings',
            cardType: CARD_TYPES.DETAILS,
            parseResponse: parsePotentialSavingsResponse,
            values: potentialSavingsCardValues,
        },
        {
            id: 'topTenOpportunities',
            cardType: CARD_TYPES.TOP_TEN_OPPORTUNITIES,
            parseResponse: parseTopTenOpportunitiesResponse,
            values: topTenOpportunitiesCardValues,
        },
    ];

    const cards = useMemo(() =>
        buildCards(
            getCardConfigs(),
            { summaryData, osPricingData: modernizationPricingData, queryState, isPricingLoading, isPricingError },
            { onIgnoreOptimizations },
        ),
        [summaryData, modernizationPricingData, queryState, isPricingLoading, isPricingError, onIgnoreOptimizations]
    );

    return <SummaryCardRenderer cards={cards} queryState={queryState} />;
};
